import { styled } from '@arpeggi/ui'

const Root = styled('button', {
  all: 'unset',
  width: '48px',
  height: '48px',
  borderRadius: '999px',
  color: '$black',
  background: 'transparent',
  display: 'flex',
  fontSize: '12px',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'all 100ms ease',
  '&:hover': {
    background: '$blackA050'
  },
  '&:active': {
    background: '$blackA100'
  },
  '&:disabled': {
    opacity: 0.3
  }
})

const Icon = styled('svg', {
  width: '20px',
  height: '20px',
  color: 'inherit'
})

export const Favorite = { Root, Icon }
